export default __webpack_public_path__ + "static/media/PlaceholderImage.6b8c9670.svg";